// Parses a daily log "Date of Visit" value into a comparable timestamp.
// The API can return it either as the raw DB value (YYYY-MM-DD) or as the
// formatted value (DD-MM-YYYY), so both are handled here.
export const parseVisitDate = (value) => {
  if (!value) return 0;
  const raw = String(value).trim();

  const yearFirst = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (yearFirst) {
    return new Date(
      Number(yearFirst[1]),
      Number(yearFirst[2]) - 1,
      Number(yearFirst[3])
    ).getTime();
  }

  const dayFirst = raw.match(/^(\d{1,2})-(\d{1,2})-(\d{4})/);
  if (dayFirst) {
    return new Date(
      Number(dayFirst[3]),
      Number(dayFirst[2]) - 1,
      Number(dayFirst[1])
    ).getTime();
  }

  const parsed = new Date(raw);
  return isNaN(parsed.getTime()) ? 0 : parsed.getTime();
};

// Newest Date of Visit first, records without a visit date last.
export const sortByVisitDateDesc = (rows) => {
  if (!Array.isArray(rows)) return [];
  return [...rows].sort(
    (first, second) =>
      parseVisitDate(second.cnd_daily_logs_date) -
      parseVisitDate(first.cnd_daily_logs_date)
  );
};
